module.exports = __webpack_public_path__ + "img/ic_google_2.359bccc4.svg";